<template>
    <div>
        <template>
            <div class="manage--main">
                <div class="header-manage">
                    <div class="user-name" id="clm" v-if="mobile && !menu">
                        <template v-if="courseName != null && courseName.search('@') !== -1">{{courseName}}</template>
                        <template v-if="courseName != null && courseName.search('@') == -1">{{courseName}}</template>
                    </div>
                    <div class="user-namesss" v-if="mobile && menu">
                        <template v-if="courseName != null && courseName.search('@') !== -1">{{courseName}}</template>
                        <template v-if="courseName != null && courseName.search('@') == -1">{{courseName}}</template>
                    </div>
                    <div class="icon-img-right" @click="showUser()">
                        <template v-if="menu"><img src="../../../static/images/icon-cb-trang.png" /></template>
                        <template v-else><img src="../../../static/images/mucluc-trang.png" /></template>
                    </div>
                </div>
                <!-- left -->
                <left :data="{dataGeneral: dataGeneral}" v-on:changeItem="changeItem($event)"></left>
                <!-- main -->
                <contentManage :data="{data: dataContent}"></contentManage>
            </div>
        </template>
    </div>
</template>

<script>
    import left from "@/components/manual/left_manual";
    import contentManage from "@/components/manual/content_manual";

    export default {
        data() {
            return {
                dataGeneral: [
                    {
                        menuId: 0,
                        menuName: this.$t("manualNew.type_1"),
                        contentList: [
                            {
                                type: 0,
                                name: this.$t("manualNew.type_1_1"),
                                isMobile: true
                            },
                            {
                                type: 1,
                                name: this.$t("manualNew.type_1_2"),
                                isMobile: true
                            }
                        ],
                    },
                    {
                        menuId: 1,
                        menuName: this.$t("manualNew.type_2"),
                        contentList: [
                            {
                                type: 2,
                                name: this.$t("manualNew.type_2_1"),
                                isMobile: true
                            },
                            {
                                type: 3,
                                name: this.$t("manualNew.type_2_2"),
                                isMobile: true
                            },
                            {
                                type: 4,
                                name: this.$t("manualNew.type_2_3"),
                                isMobile: true
                            },
                            {
                                type: 5,
                                name: this.$t("manualNew.type_2_4"),
                                isMobile: true
                            }
                        ],
                    },
                    {
                        menuId: 2,
                        menuName: this.$t("manualNew.type_3"),
                        contentList: [
                            {
                                type: 6,
                                name: this.$t("manualNew.type_3_1"),
                                isMobile: true
                            },
                            {
                                type: 7,
                                name: this.$t("manualNew.type_3_2"),
                                isMobile: true
                            },
                            {
                                type: 8,
                                name: this.$t("manualNew.type_3_3"),
                                isMobile: true
                            },
                            {
                                type: 31,
                                name: this.$t("manualNew.type_3_3_1"),
                                isMobile: true
                            },
                            {
                                type: 32,
                                name: this.$t("manualNew.type_3_3_2"),
                                isMobile: true
                            },
                            {
                                type: 33,
                                name: this.$t("manualNew.type_3_3_3"),
                                isMobile: true
                            },
                            {
                                type: 34,
                                name: this.$t("manualNew.type_3_3_4"),
                                isMobile: true
                            },
                            {
                                type: 35,
                                name: this.$t("manualNew.type_3_3_5"),
                                isMobile: true
                            },
                            {
                                type: 36,
                                name: this.$t("manualNew.type_3_3_6"),
                                isMobile: true
                            },
                            {
                                type: 37,
                                name: this.$t("manualNew.type_3_3_7"),
                                isMobile: true
                            },
                            {
                                type: 38,
                                name: this.$t("manualNew.type_3_3_8"),
                                isMobile: true
                            },
                            {
                                type: 39,
                                name: this.$t("manualNew.type_3_3_9"),
                                isMobile: true
                            },
                            {
                                type: 40,
                                name: this.$t("manualNew.type_3_3_10"),
                                isMobile: true
                            },
                            {
                                type: 9,
                                name: this.$t("manualNew.type_3_4"),
                                isMobile: true
                            },
                            {
                                type: 10,
                                name: this.$t("manualNew.type_3_5"),
                                isMobile: true
                            },
                            {
                                type: 11,
                                name: this.$t("manualNew.type_3_6"),
                                isMobile: true
                            },
                            {
                                type: 12,
                                name: this.$t("manualNew.type_3_7"),
                                isMobile: true
                            },
                            {
                                type: 13,
                                name: this.$t("manualNew.type_3_8"),
                                isMobile: true
                            },
                            {
                                type: 14,
                                name: this.$t("manualNew.type_3_9"),
                                isMobile: false
                            },
                            {
                                type: 15,
                                name: this.$t("manualNew.type_3_10"),
                                isMobile: true
                            },
                        ],
                    },
                    {
                        menuId: 3,
                        menuName: this.$t("manualNew.type_4"),
                        contentList: [
                            {
                                type: 16,
                                name: this.$t("manualNew.type_4_1"),
                                isMobile: true
                            },
                            {
                                type: 17,
                                name: this.$t("manualNew.type_4_2"),
                                isMobile: true
                            }
                        ],
                    },
                    {
                        menuId: 4,
                        menuName: this.$t("manualNew.type_5"),
                        contentList: [
                            {
                                type: 18,
                                name: this.$t("manualNew.type_5_1"),
                                isMobile: true
                            },
                            {
                                type: 19,
                                name: this.$t("manualNew.type_5_2"),
                                isMobile: true
                            }
                        ],
                    },
                    {
                        menuId: 5,
                        menuName: this.$t("manualNew.type_6"),
                        contentList: [
                            {
                                type: 20,
                                name: this.$t("manualNew.type_6_1"),
                                isMobile: true
                            },
                            {
                                type: 21,
                                name: this.$t("manualNew.type_6_2"),
                                isMobile: true
                            },
                            {
                                type: 22,
                                name: this.$t("manualNew.type_6_3"),
                                isMobile: true
                            },
                            {
                                type: 23,
                                name: this.$t("manualNew.type_6_4"),
                                isMobile: true
                            }
                        ],
                    },
                    {
                        menuId: 6,
                        menuName: this.$t("manualNew.type_7"),
                        contentList: [
                            {
                                type: 24,
                                name: this.$t("manualNew.type_7_1"),
                                isMobile: true
                            },
                            {
                                type: 25,
                                name: this.$t("manualNew.type_7_2"),
                                isMobile: true
                            },
                            {
                                type: 26,
                                name: this.$t("manualNew.type_7_3"),
                                isMobile: true
                            },
                            {
                                type: 27,
                                name: this.$t("manualNew.type_7_4"),
                                isMobile: true
                            },
                            {
                                type: 28,
                                name: this.$t("manualNew.type_7_5"),
                                isMobile: true
                            }
                        ],
                    },
                ],
                // dataManage: [
                //     {
                //         menuId: 6,
                //         menuName: this.$t("manage.manage_info"),
                //         contentList: [
                //             {
                //                 type: 24,
                //                 name: this.$t("manual.achievementStudent"),
                //                 isMobile: true
                //             },
                //             {
                //                 type: 25,
                //                 name: this.$t("manage.student"),
                //                 isMobile: true
                //             },
                //             {
                //                 type: 26,
                //                 name: this.$t("manage.lesson"),
                //                 isMobile: true
                //             },
                //             {
                //                 type: 27,
                //                 name: this.$t("manage.attendance"),
                //                 isMobile: true
                //             },
                //             {
                //                 type: 28,
                //                 name: this.$t("home.liveMessage"),
                //                 isMobile: false
                //             }
                //         ],
                //     },
                // ],
                courseName: this.$t("manual.settingProcedure"),
                menu: true,
                dataContent: {},
            };
        },
        components: {
            left,
            contentManage,
        },
        mounted() {
            if (this.checkMobile()) {
                this.dataContent.type = 0;
                document.getElementsByTagName("body")[this.$CONST.COMMON.NUMBER.ZERO].classList.toggle("show-menu-1");
            }
        },
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        methods: {
            changeItem: function (params) {
                this.menu = !this.menu;
                this.dataContent = params;
                this.courseName = params.name;
            },
            showUser: function () {
                this.menu = !this.menu;
                document.getElementsByTagName("body")[this.$CONST.COMMON.NUMBER.ZERO].classList.toggle("show-menu-1");
            },
        },
    };
</script>
<style scoped>
    .exam_btn.btn-login.disable {
        background: #d2d2d2 !important;
        cursor: no-drop;
    }
    .primarylists {
        margin-top: 15px;
        margin-left: 15px;
    }
    .nameStudent {
        color: #da251d;
    }
    .user-name {
        margin-left: 4px;
    }
    .user-name.ml {
        margin-left: 50px;
    }
    .user-namesss {
        font-weight: bold;
        padding: 0 5px;
        text-transform: uppercase;
        font-size: 18px;
        color: #fff;
        margin-left: 4px;
        text-overflow: ellipsis !important;
        overflow: hidden;
        white-space: nowrap;
    }
    .title-flex {
        display: flex;
        align-items: center;
    }
    .new-btn {
        margin: 0 0px 0 10px !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/index/manual.vue